import { gql } from "@apollo/client";

export const enforcementIntentSummaryFragment = gql`
  fragment enforcementIntentSummaryFragment on enforcement_intent {
    id
    code
    status
    noticeNumber: notice_number
    noticeType: type
    timezone
    issuedAt: issued_at
    totalAmountDue: total_amount_due
    licensePlateNumber: license_plate_number
    licensePlateRegion: license_plate_region
    violationType: violation_type
    reviews {
      id
      type
      status
      deniedReason: denied_reason
      requestedAt: requested_at
      reviewedAt: reviewed_at
    }
  }
`;

export interface EnforcementIntentSummary {
  id: string;
  code: string;
  status: EnforcementIntentStatus;
  noticeNumber: string;
  noticeType: EnforcementIntentType;
  timezone: string;
  issuedAt: string;
  totalAmountDue: number;
  licensePlateNumber: string;
  licensePlateRegion: string;
  violationType: string; // TODO: enum
  reviews: {
    id: string;
    type: string; // TODO: enum
    status: string; // TODO: enum
    deniedReason: string | null;
    requestedAt: string;
    reviewedAt: string | null;
  }[];
}

export type EnforcementIntentStatus =
  | "requires_internal_review"
  | "requires_officer_review"
  | "requires_ro_lookup"
  | "requires_mailing"
  | "requires_payment"
  | "requires_dispute_resolution"
  | "paid"
  | "voided"
  | "sent_to_collections"
  | "notification_delivered"
  | "awaiting_ro_lookup_result"
  | "awaiting_initial_letter";

export type EnforcementIntentSimpleStatus = "pending" | "issued" | "voided";

export const enforcementIntentSimpleStatus: Record<EnforcementIntentStatus, EnforcementIntentSimpleStatus> = {
  requires_internal_review: "pending",
  requires_officer_review: "pending",
  requires_ro_lookup: "pending",
  requires_mailing: "issued",
  requires_payment: "issued",
  requires_dispute_resolution: "issued",
  paid: "issued",
  voided: "voided",
  sent_to_collections: "issued",
  notification_delivered: "issued",
  awaiting_ro_lookup_result: "issued",
  awaiting_initial_letter: "issued",
};

export type EnforcementIntentType = "citation" | "invoice";
